import { LoginPageContent } from '@pages/Anonymous/LoginPage/components/Content';
import { PageProvider } from '@pages/Anonymous/LoginPage/providers/PageProvider';
import type { TDesktopSignIn } from '@pages/Anonymous/LoginPage/types';

type TProps = {
  onSignedIn?: () => void;
  desktop?: TDesktopSignIn;
};

export const LoginPage = ({ onSignedIn, desktop }: TProps) => {
  return (
    <PageProvider onSignedIn={onSignedIn} desktop={desktop}>
      <LoginPageContent desktop={desktop} />
    </PageProvider>
  );
};
